import React, { useEffect } from 'react'
import { withRouter, useParams, useLocation } from 'react-router-dom'

import { compose } from 'redux'
import { connect } from 'react-redux'
import { actionDetailProduct } from '../../store/actions/product'
import { actionAddCart } from '../../store/actions/cart'
import { actionSettingReferral } from '../../store/actions/util'
import { actionSaveTransaction } from '../../store/actions/transaction'

import { Loader } from '../../components'
import { getCleanUrlReferral } from '../../helpers'
import { ProductReferralLanding } from '../Product/components'

const ProductLanding = ({
  history,
  product,
  authenticate,
  util,
  transaction,
  dispatchDetailProduct,
  dispatchAddCart,
  dispatchSettingReferral,
  dispatchSaveTransaction
}) => {
  const { id } = useParams()
  const location = useLocation()
  const referralParam = getCleanUrlReferral(location, history)

  useEffect(() => {
    if (referralParam) {
      dispatchSettingReferral()
    }
  }, [referralParam, dispatchSettingReferral])

  useEffect(() => {
    if (id) {
      dispatchDetailProduct(id)
    }
  }, [id, dispatchDetailProduct])

  if (product.loading || !product.payload) return <Loader />

  const referralDiscount = referralParam ? util?.settingReferral?.payload?.price_discount : null

  return (
    <ProductReferralLanding
      productPayload={product.payload}
      account={authenticate.account}
      referralCode={referralParam}
      referralDiscount={referralDiscount}
      contactPhone={util?.contact?.payload?.phone}
      history={history}
      dispatchAddCart={dispatchAddCart}
      dispatchSaveTransaction={dispatchSaveTransaction}
      transactionLoading={transaction.loading}
      transactionPayload={transaction.payload}
      authenticateAccount={authenticate.account}
      voucherPayload={null}
      activeReferralCode={referralParam}
    />
  )
}

const mapStateToProps = (state) => {
  return {
    authenticate: {
      account: state.auth.authenticate.account
    },
    product: {
      loading: state.product.detailProduct.loading,
      payload: state.product.detailProduct.payload
    },
    transaction: {
      loading: state.transaction.saveTransaction.loading,
      payload: state.transaction.saveTransaction.payload
    },
    util: {
      contact: state.util.contact,
      settingReferral: state.util.settingReferral
    }
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatchDetailProduct: (productId) => dispatch(actionDetailProduct(productId)),
    dispatchAddCart: (product, price, quantity, isSilent) => dispatch(actionAddCart(product, price, quantity, isSilent)),
    dispatchSettingReferral: () => dispatch(actionSettingReferral()),
    dispatchSaveTransaction: (data) => dispatch(actionSaveTransaction(data))
  }
}

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(ProductLanding)
